import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    HStack,
    Icon,
    MenuItem,
    Text,
    useDisclosure,
    VStack,
} from '@chakra-ui/react';
import { createRef } from 'react';
import { BiPhone, BiSolidPhone } from 'react-icons/bi';
import { FaBriefcaseMedical } from 'react-icons/fa';

export interface IContactProps {}

export function Contact(props: IContactProps) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = createRef<HTMLButtonElement>();

    return (
        <>
            <MenuItem onClick={onOpen}>Kontakt na organizátory</MenuItem>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent color="gray.200">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Kontakt na organizátory
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            V případě jakéhokoli problému prosím kontaktujte telefonicky organizátory.
                            <VStack alignItems="stretch" mt={6} spacing={2}>
                                <Text as="h3" fontSize="l" fontWeight="bold">
                                    Organizátoři
                                </Text>
                                <HStack>
                                    <Icon as={BiSolidPhone} />
                                    <Text flexGrow={1}>Jonáš „Sony“ Rosecký</Text>
                                    <Button as="a" href="tel:+420730585427" w={40}>
                                        +420 730 585 427
                                    </Button>
                                </HStack>
                                <HStack>
                                    <Icon as={BiPhone} />
                                    <Text flexGrow={1}>David „Heri“ Novotný </Text>
                                    <Button as="a" href="tel:+420731333195" w={40}>
                                        +420 731 333 195
                                    </Button>
                                </HStack>
                                <Text as="h3" fontSize="l" fontWeight="bold" mt={6}>
                                    Zdravotník
                                </Text>
                                <HStack>
                                    <Icon as={FaBriefcaseMedical} />
                                    <Text flexGrow={1}>Jarda „Hedva“ Hedvičák</Text>
                                    <Button as="a" href="tel:+420777635690" w={40}>
                                        +420 777 635 690
                                    </Button>
                                </HStack>
                            </VStack>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Zavřít
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
}
